import { Bar, BarChart, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

import { ChartData } from "../RankifierChart";
import { ChartTooltip } from "../../ChartTooltip";

export const NetScoreChart = ({ data }: { data: ChartData[] }) => {
  return (
    <ResponsiveContainer width="100%" height="100%" minHeight={400}>
      <BarChart
        layout="vertical"
        width={500}
        height={400}
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <XAxis type="number" tick={{ fontSize: "14px", color: "#4E4F4B" }} tickLine={false} />
        <YAxis
          width={200}
          type="category"
          dataKey="name"
          tick={{ fontSize: "14px", color: "#4E4F4B" }}
          tickLine={false}
        />

        <Tooltip content={<ChartTooltip translation="report:rankifier.score" />} cursor={{ fill: "#E8E8E8" }} />
        <ReferenceLine x={0} />

        <Bar dataKey="score" fill="#F6A16F" />
      </BarChart>
    </ResponsiveContainer>
  );
};
